import { GetSiteOutput } from "@amzn/ttechclaimintakeservice-client";
import { SimLinkClaimAdditionalFields, SimLinkClaimModel } from "src/app/types";
import { INCIDENT_DETAILS_CONSTANTS } from "src/forms/Cargo/constants";
import { FormStateType } from "src/forms/types";

export function convertFormToSymLinkClaimModel(formState: FormStateType, additionalFields: SimLinkClaimAdditionalFields): SimLinkClaimModel {
    return {
        amazonClaimReferenceId: additionalFields.amazonClaimReferenceId,
        associateAlias: formState["associateAlias"]?.value,
        associateEmployeeId: formState["associateEmployeeId"]?.value,
        associateFirstName: formState["associateFirstName"]?.value,
        associateLastName: formState["associateLastName"]?.value,
        incidentDate: formState[INCIDENT_DETAILS_CONSTANTS.INCIDENT_DATE]?.value,
        incidentSiteName: additionalFields.incidentSite?.code,
        notificationAliasList: additionalFields?.associateHomeSite?.notificationAliasList,
        notificationWebhook: additionalFields?.associateHomeSite?.notificationWebhook, 

        // Appears to only be used by other converter below
        // code
        // name
    }
}

export function convertAssociateHomeSiteToSymLinkClaimModel(associateHomeSite: GetSiteOutput): SimLinkClaimModel {
    return {
        code: associateHomeSite.code,
        name: associateHomeSite.name,
        notificationAliasList: associateHomeSite.notificationAliasList,
        notificationWebhook: associateHomeSite.notificationWebhook, 
    }
}